import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Grid } from '@mui/joy';
import { IoLogoFacebook } from "react-icons/io5";
import { AiFillInstagram } from "react-icons/ai";
import { AiFillTwitterCircle } from "react-icons/ai";

const Footer = () => {
    return (
        <>
            <Box sx={{ backgroundColor: '#000', width: '100%', height: '220px', display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '1153px', margin: 'auto', }}>
                    <Grid container spacing={3} justifyContent="space-between" alignItems="center">
                        <Grid item xs={6} md={6}>
                            <a href="/" style={{ textDecoration: 'none' }}>
                                <img
                                    width="130"
                                    height="35"
                                    id="logo-img"
                                    className="img-fluid"
                                    alt="Fundi Logo"
                                    src={`assets/images/${"fundi_tz_logo_high_res_final copy 1"}.png`}
                                />
                            </a>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Box display="flex" justifyContent="flex-end" >
                                <IconButton href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                                    sx={{

                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        }
                                    }}
                                >
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding:'0px',
                                            width: '40px',            
                                            height: '40px',             
                                         
                                        }}
                                    >
                                    <img width={40} height={40} src={`assets/images/${"Facebook"}.png`} alt="" />
                                        {/* <IoLogoFacebook color='#28A745' fontSize={40} padding='0px !important' /> */}
                                    </span>
                                </IconButton>
                                <IconButton href="https://instagram.com" target="_blank" rel="noopener noreferrer"
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        }
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: 40,
                                            height: 40,
                                            borderRadius: '50%',
                                            backgroundColor: '#28A745',
                                            p: 0

                                        }}
                                    >
                                        <AiFillInstagram color='#ffffff' fontSize={25} />
                                    </Box>
                                </IconButton>
                                <IconButton href="https://twitter.com" target="_blank" rel="noopener noreferrer"
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        }
                                    }}
                                >
                                 <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding:'0px',
                                            width: '40px',            
                                            height: '40px',             
                                         
                                        }}
                                    >
                                    <img width={40} height={40} src={`assets/images/${"Twitter"}.png`} alt="" />
                                        {/* <IoLogoFacebook color='#28A745' fontSize={40} padding='0px !important' /> */}
                                    </span>
                                    {/* <AiFillTwitterCircle color='#28A745' fontSize={40} /> */}
                                </IconButton>
                            </Box>
                            <Box display="flex" justifyContent="flex-end" gap={3} mt={2}>
                                <a href="https://appstore.com" target="_blank" rel="noopener noreferrer">
                                    <img width="150px" height="50px" src={`assets/images/${"App Store"}.png`} alt="App Store" />
                                </a>
                                <a href="https://play.google.com" target="_blank" rel="noopener noreferrer">
                                    <img width="150px" height="50px" src={`assets/images/${"Google Play"}.png`} alt="Google Play" />
                                </a>
                            </Box>
                            <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                                <Typography variant="body2" component="a" href="/policy" sx={{ textDecoration: 'none', color: '#fff' }}>
                                    Policy
                                </Typography>
                                <Typography variant="body2" component="a" href="/terms" sx={{ textDecoration: 'none', color: '#fff' }}>
                                    Terms of Condition
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {/* <Footers/> */}
        </>
    );
};

export default Footer;
